import { useQuery } from "react-query";
import { uncoveryApi } from "services";

const fetchCountSeverities = async ({ entityId, status }) => {
  const qsStatus = status ? status.join("&status=") : "";
  const query = `/issues/count/severities?entityId=${entityId}${
    qsStatus ? `&status=${qsStatus}` : ``
  }`;
  const { data } = await uncoveryApi.get(query);
  return data.data;
};

export default function useFetchCountSeverities({
  entityId = null,
  status = null,
}) {
  return useQuery(
    ["issuesCountSeverities", entityId, status],
    () => fetchCountSeverities({ entityId, status }),
    {
      enabled: !!entityId && !!status,
    }
  );
}
